import { render, staticRenderFns } from "./OrderWizard.vue?vue&type=template&id=d47ce14a&"
import script from "./OrderWizard.vue?vue&type=script&lang=js&"
export * from "./OrderWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports